__turbopack_context__.v({
  "container": "M4wL3a_container",
  "footer": "M4wL3a_footer",
  "languageButton": "M4wL3a_languageButton",
  "selected": "M4wL3a_selected",
});
